export default "__VITE_ASSET__JF6$Idvs__"